import React, { useState, useEffect } from "react";
import logo from "../../../Assests/RebelSkool.png";
import { Image } from "primereact/image";
import svFlag from "../../../Assests/sweden_flag.webp";
import enFlag from "../../../Assests/USUK_Flag.jpg";
import { Dropdown } from "primereact/dropdown";
import TranslationFile from "../../15-Translation/locale/Translation_apps.json";
import "./ExternalNavBarHeader.css";

const flagdropdown = [
  { language: "sw", flag: svFlag },
  { language: "en", flag: enFlag }
];

const readCurrentUser = () => {
  try {
    return JSON.parse(localStorage.getItem("RBLExternalUserDetails"));
  } catch (err) {
    return null;
  }
};

const getUserName = (user) =>
  (user &&
    (user.userName ||
      user.UserName ||
      user.username ||
      user.name ||
      [user.firstName, user.lastName].filter(Boolean).join(" "))) ||
  "";

const flagOnClick = (langCode) => {
  localStorage.setItem("selectedLanguage", langCode === "sw" ? "sw" : "en");
  window.location.reload(false);
};

const signOut = (e) => {
  e.preventDefault();
  localStorage.removeItem("RBLExternalUserDetails");
  window.location.href = "/external/login";
};

const ExternalNavBarHeader = () => {
  const [userSelectedLanguage] = useState(
    () => localStorage.getItem("selectedLanguage") || "en"
  );
  const [currentUser, setCurrentUser] = useState(readCurrentUser);
  const [currentPage, setCurrentPage] = useState("main");
  const [hamburgerOpen, setHamburgerOpen] = useState(false);

  useEffect(() => {
    const refresh = () => setCurrentUser(readCurrentUser());

    refresh();
    window.addEventListener("RBLUserUpdated", refresh);
    window.addEventListener("storage", refresh);
    return () => {
      window.removeEventListener("RBLUserUpdated", refresh);
      window.removeEventListener("storage", refresh);
    };
  }, []);

  useEffect(() => {
    if (getUserName(currentUser)) return;

    const id = setInterval(() => {
      const u = readCurrentUser();
      if (getUserName(u)) {
        setCurrentUser(u);
        clearInterval(id);
      }
    }, 500);
    const stop = setTimeout(() => clearInterval(id), 10000);

    return () => {
      clearInterval(id);
      clearTimeout(stop);
    };
  }, [currentUser]);

  const userNameFromLS = getUserName(currentUser);
  const showName = !!userNameFromLS;

  const goToPage = (page) => setCurrentPage(page);

  const toggleHamburger = () => {
    setHamburgerOpen((prev) => !prev);
    setCurrentPage("main");
  };

  const AccountDropdown = [
    /* {
      label: TranslationFile.myProfileText[userSelectedLanguage],
      icon: "pi pi-fw pi-user",
      command: () => {
        window.location.href = getProfileUrl(userGUID);
      }
    }, */
    {
      label: TranslationFile.SignOut_Text[userSelectedLanguage],
      icon: "pi pi-fw pi-power-off",
      command: (e) => {
        signOut(e);
      }
    }
  ];

  const selectedFlag =
    flagdropdown.find((option) => option.language === userSelectedLanguage) ||
    flagdropdown[1];

  return (
    <>
      <nav
        className="HeaderNavBar"
        style={{
          display: "flex",
          width: "100%",
          justifyContent: "space-between",
          zIndex: 1000,
          position: "sticky",
          top: 0,
          backgroundColor: "white",
          // marginBottom: "2px",
          borderBottom: "1px solid #ccc",
          boxShadow: "0 4px 4px rgba(0,0,0,0.1)"
        }}
      >
        <div>
          <a href="/external/login">
            <Image src={logo} alt="Logo" />
          </a>
        </div>

        <div className="HeaderNavBar_ul">
          <ul
            type="none"
            style={{
              display: "flex",
              alignItems: "center",
              gap: "30px",
              margin: 0,
              padding: 0
            }}
          >
            <li>
              <Dropdown
                className="flag-dropdown"
                value={flagdropdown.find(
                  (option) => option.language === userSelectedLanguage
                )}
                options={flagdropdown}
                optionLabel="language"
                itemTemplate={(option) => (
                  <Image
                    className="flag-item"
                    src={option.flag}
                    alt={option.language}
                    width="35"
                    height="25"
                  />
                )}
                valueTemplate={(option) => {
                  if (!option) {
                    return null;
                  }
                  return (
                    <Image
                      className="selected-flag"
                      src={option.flag}
                      alt={option.language}
                      width="30"
                      height="20"
                    />
                  );
                }}
                onChange={(e) => {
                  flagOnClick(e.value.language);
                }}
              />
            </li>
            {/* {showName && ( */}
            <li>
              <Dropdown
                className="account-dropdown"
                value={null}
                options={AccountDropdown}
                optionLabel="label"
                itemTemplate={(option) => (
                  <span>
                    <i className={option.icon}></i> {option.label}
                  </span>
                )}
                onChange={(e) => {
                  e.value.command(e);
                }}
                placeholder={
                  TranslationFile.loginHiText[userSelectedLanguage] +
                  " " +
                  userNameFromLS
                }
              />
            </li>
            {/* )} */}
          </ul>
        </div>

        <div className="HeaderNavBar_hamburger">
          <i
            className={`pi ${hamburgerOpen ? "pi-times" : "pi-bars"}`}
            style={{ fontSize: "1.5rem", cursor: "pointer" }}
            onClick={toggleHamburger}
          />

          <div
            className={`hamburger-menu ${
              hamburgerOpen ? "hamburger-menu-open" : ""
            }`}
          >
            <div
              className="hamburger-slider"
              style={{
                transform:
                  currentPage === "main"
                    ? "translateX(0%)"
                    : "translateX(-33.333%)"
              }}
            >
              {/* MAIN PAGE */}
              <div className="hamburger-page hamburger-page-main">
                <div
                  className="hamburger-logo"
                  style={{ marginBottom: "10px" }}
                >
                  <Image className="hamburger-logo-img" src={logo} alt="Logo" />
                </div>

                <ul type="none" style={{ padding: 0, margin: 0 }}>
                  <li
                    className="hamburger-li"
                    onClick={() => goToPage("list2")}
                  >
                    <div>
                      <Image
                        className="selected-flag"
                        src={selectedFlag.flag}
                        alt={selectedFlag.language}
                        width="30"
                        height="20"
                      />
                      <span style={{ marginLeft: "10px" }}>
                        {userSelectedLanguage === "en" ? "English" : "Svenska"}
                      </span>
                    </div>
                    <i className="pi pi-angle-right" />
                  </li>
                  {showName && (
                    <li
                      className="hamburger-li"
                      onClick={() => goToPage("list3")}
                    >
                      {TranslationFile.loginHiText[userSelectedLanguage] +
                        " " +
                        userNameFromLS}
                      <i className="pi pi-angle-right" />
                    </li>
                  )}
                </ul>
              </div>

              {/* LANGUAGE SUBPAGE */}
              {currentPage === "list2" ? (
                <div className="hamburger-page hamburger-page-list2">
                  <div
                    className="hamburger-back"
                    onClick={() => goToPage("main")}
                  >
                    <i className="pi pi-angle-left" />
                    Back
                  </div>

                  <ul type="none" style={{ padding: 0, margin: 0 }}>
                    <li className="hamburger-li">
                      <div onClick={() => flagOnClick("sw")}>
                        <Image
                          className="selected-flag"
                          src={svFlag}
                          alt="sw"
                          width="30"
                          height="20"
                        />
                        <span style={{ marginLeft: "10px" }}>Svenska</span>
                      </div>
                    </li>

                    <li className="hamburger-li">
                      <div onClick={() => flagOnClick("en")}>
                        <Image
                          className="selected-flag"
                          src={enFlag}
                          alt="en"
                          width="30"
                          height="20"
                        />
                        <span style={{ marginLeft: "10px" }}>English</span>
                      </div>
                    </li>
                  </ul>
                </div>
              ) : (
                currentPage === "list3" && (
                  <div className="hamburger-page hamburger-page-list3">
                    <div
                      className="hamburger-back"
                      onClick={() => goToPage("main")}
                    >
                      <i className="pi pi-angle-left" />
                      Back
                    </div>
                    {/*  <div
                      onClick={() =>
                        (window.location.href = getProfileUrl(userGUID))
                      }
                      className="hamburger-li hamburger-li-profile"
                    >
                      <i className="pi pi-user" />
                      <span>
                        {TranslationFile.myProfileText[userSelectedLanguage]}
                      </span>
                    </div> */}
                    <div onClick={(e) => signOut(e)} className="hamburger-li">
                      <i className="pi pi-power-off" />
                      <span>
                        {TranslationFile.SignOut_Text[userSelectedLanguage]}
                      </span>
                    </div>
                  </div>
                )
              )}
            </div>
          </div>
        </div>
      </nav>
    </>
  );
};

export default ExternalNavBarHeader;
